import React from 'react';
import { Box } from '../Box';
import { Text } from '../Text';

export function Suffix({ children }: { children: React.ReactNode }) {
    return (
        <Box display="flex" alignItems="center" marginLeft="quarterGutter">
            {typeof children === 'string' ? <Text size="size2">{children}</Text> : children}
        </Box>
    );
}
